import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavigationMenuVerticalBold = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "navigation-menu-vertical" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 3.25,
			r: 3.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 3.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 20.75,
			r: 3.25
		})
	]
});
export default SvgNavigationMenuVerticalBold;
